import { objectSpread2 as _objectSpread2, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useMemo } from 'react';
import { presets, useSafeThemeUI, ThemeUIProvider, utils } from '@costar/theme-ui';
import { Toast } from './toast-component.esm.js';
import { defaults } from './toast.utils.esm.js';
import { getToastPlacement } from './toast.placement.esm.js';
import { globalToastStore, createStore, initialState } from './toast-manager.esm.js';
import { LocalToastHostContainer } from './local-toast-host-container.esm.js';

var defaultParam = {
  theme: presets.getBaseTheme('rem', 'suite'),
  defaultOptions: defaults
};
function createToastFn() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultParam,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? defaultParam.theme : _ref$theme,
    _ref$defaultOptions = _ref.defaultOptions,
    defaultOptions = _ref$defaultOptions === void 0 ? defaultParam.defaultOptions : _ref$defaultOptions,
    localToastStore = _ref.toastStore;
  var toastStoreToUse = localToastStore !== null && localToastStore !== void 0 ? localToastStore : globalToastStore;
  var renderWithProviders = function renderWithProviders(props, options) {
    // const { id } = props
    // eslint-disable-next-line no-console
    // console.log(`render toast id: ${id}`)
    return /*#__PURE__*/React.createElement(ThemeUIProvider, {
      theme: theme
    }, options.render && utils.isFunction(options.render) ? options.render(props) : /*#__PURE__*/React.createElement(Toast, _extends({}, options, props)));
  };
  var toastImpl = function toastImpl(options) {
    var opts = _objectSpread2(_objectSpread2({}, defaultOptions), options);
    opts.position = getToastPlacement(opts.position, theme.direction);
    var Message = function Message(props) {
      return renderWithProviders(props, opts);
    };
    return toastStoreToUse.notify(Message, opts, localToastStore);
  };
  toastImpl.close = toastStoreToUse.close;
  toastImpl.closeAll = toastStoreToUse.closeAll;
  toastImpl.isVisible = toastStoreToUse.isVisible;
  toastImpl.update = function (id, options) {
    if (!id) return;
    var opts = options;
    toastStoreToUse.update(id, _objectSpread2(_objectSpread2({}, opts), opts.position ? {
      position: getToastPlacement(opts.position, theme.direction)
    } : {}));
  };
  return toastImpl;
}

/**
 * Hook that provides toast notifications.
 * @param options - Configuration options for the toast.
 * @param isGlobal - Indicates whether the toast is global. True by default.
 * @returns A tuple where the first element is a function that allows creating, updating, and closing toasts, and the second element is a component that hosts toasts.
 *
 * The options and isGlobal parameters should be memoized to prevent unnecessary re-renders and computations.
 * To create toasts under a container (i.e mapview or placards) set isGlobal = False and pass in containerRef for options.
 * LocalToastContainer is a component that hosts toasts.
 * toast is a function that allows creating, updating, closing individual toasts and closing all toasts.
 */
function useToast(options) {
  var isGlobal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var theme = useSafeThemeUI();
  var _useMemo = useMemo(function () {
      var toastStore = isGlobal ? undefined : createStore(initialState);
      var toast = createToastFn({
        theme: theme,
        defaultOptions: options,
        toastStore: toastStore
      });
      var LocalToastContainer = toastStore && options ? function () {
        return /*#__PURE__*/React.createElement(LocalToastHostContainer, {
          container: options.container,
          offset: options.offset,
          toastStore: toastStore
        });
      } : function () {
        return null;
      };
      return {
        toast: toast,
        LocalToastContainer: LocalToastContainer
      };
    }, [options, isGlobal, theme]),
    toast = _useMemo.toast,
    LocalToastContainer = _useMemo.LocalToastContainer;
  return [toast, LocalToastContainer];
}

export default useToast;
export { createToastFn, defaultParam, useToast };
//# sourceMappingURL=use-toast.esm.js.map
